// v1 without pdf valida`tion

// import React, { useState } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
// } from "@mui/material";
// import UploadWithLabel from "./uploadWithLable";
// import TwoFieldRow from "./twoFieldsRow";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const LegalHeirInfoSection = ({ legalHeir, setLegalHeir, activeTab, setActiveTab }) => {
//   const { t } = useTranslation();
//   const [showOtherGender, setShowOtherGender] = useState(false);
//   const [showOtherRelation, setShowOtherRelation] = useState(false);

//   const validationSchema = Yup.object({
//     legal_heir_name: Yup.string().required(t('legalHeir.validation.legalHeirNameRequired')),
//     legal_heir_gender: Yup.string().required(t('legalHeir.validation.genderRequired')),
//     legal_heir_relation_with_depositor: Yup.string().required(t('legalHeir.validation.relationRequired')),
//     legal_heir_death_certificate: Yup.mixed()
//       .required(t('legalHeir.validation.deathCertRequired'))
//       .test("fileExists", t('legalHeir.validation.deathCertRequired'), value => value != null)
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     legal_heir_family_tree: Yup.mixed()
//       .required(t('legalHeir.validation.familyTreeRequired'))
//       .test("fileExists", t('legalHeir.validation.familyTreeRequired'), value => value != null)
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     legal_heir_pan_doc: Yup.mixed()
//       .required(t('legalHeir.validation.panRequired'))
//       .test("fileExists", t('legalHeir.validation.panRequired'), value => value != null)
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     legal_heir_ekyc: Yup.mixed()
//       .required(t('legalHeir.validation.ekycRequired'))
//       .test("fileExists", t('legalHeir.validation.ekycRequired'), value => value != null)
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     legal_heir_letter_of_disclosure: Yup.mixed()
//       .required(t('legalHeir.validation.disclosureRequired'))
//       .test("fileExists", t('legalHeir.validation.disclosureRequired'), value => value != null)
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     ekyc_doc_type: Yup.string().required(t('legalHeir.validation.ekycDocTypeRequired')),
//   });

//   const formik = useFormik({
//     initialValues: {
//       ...legalHeir,
//       ekyc_doc_type: legalHeir.ekyc_doc_type || "",
//     },
//     validationSchema,
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       setLegalHeir(values);
//       setActiveTab(activeTab + 1);
//     },
//   });

//   const handleFileChangeFormik = (e, fieldName) => {
//     const file = e.currentTarget.files[0] || null;
//     formik.setFieldValue(fieldName, file);
//     formik.setFieldTouched(fieldName, true);
//   };

//   const handleGenderChange = e => {
//     const value = e.target.value;
//     if (value === "other") {
//       setShowOtherGender(true);
//       formik.setFieldValue("legal_heir_gender", "");
//     } else {
//       setShowOtherGender(false);
//       formik.setFieldValue("legal_heir_gender", value);
//     }
//   };

//   const handleRelationChange = e => {
//     const value = e.target.value;
//     if (value === "other") {
//       setShowOtherRelation(true);
//       formik.setFieldValue("legal_heir_relation_with_depositor", "");
//     } else {
//       setShowOtherRelation(false);
//       formik.setFieldValue("legal_heir_relation_with_depositor", value);
//     }
//   };

//   const selectFormControlSX = { minWidth: 200, maxWidth: "100%" };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
//           {t('legalHeir.heading')}
//         </Typography>

//         <Box component="form" noValidate onSubmit={formik.handleSubmit}>
//           <Stack spacing={3}>
//             <TextField
//               margin="normal"
//               label={`${t('legalHeir.legalHeirName')} *`}
//               name="legal_heir_name"
//               value={formik.values.legal_heir_name}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               fullWidth
//               error={formik.touched.legal_heir_name && Boolean(formik.errors.legal_heir_name)}
//               helperText={formik.touched.legal_heir_name && formik.errors.legal_heir_name}
//             />

//             <TwoFieldRow>
//               <Box sx={{ minWidth: 200, flex: 1 }}>
//                 {!showOtherGender ? (
//                   <FormControl fullWidth margin="normal" error={formik.touched.legal_heir_gender && Boolean(formik.errors.legal_heir_gender)}>
//                     <InputLabel>{t('legalHeir.gender')}</InputLabel>
//                     <Select name="legal_heir_gender" value={formik.values.legal_heir_gender || ""} label={t('legalHeir.gender')} onChange={handleGenderChange} onBlur={formik.handleBlur}>
//                       <MenuItem value="male">{t('legalHeir.male')}</MenuItem>
//                       <MenuItem value="female">{t('legalHeir.female')}</MenuItem>
//                       <MenuItem value="other">{t('legalHeir.other')}</MenuItem>
//                     </Select>
//                     {formik.touched.legal_heir_gender && formik.errors.legal_heir_gender && (
//                       <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                         {formik.errors.legal_heir_gender}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 ) : (
//                   <TextField
//                     label={`${t('legalHeir.specifyGender')} *`}
//                     name="legal_heir_gender"
//                     value={formik.values.legal_heir_gender}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     fullWidth
//                     error={formik.touched.legal_heir_gender && Boolean(formik.errors.legal_heir_gender)}
//                     helperText={formik.touched.legal_heir_gender && formik.errors.legal_heir_gender}
//                     InputProps={{
//                       endAdornment: (
//                         <Button onClick={() => setShowOtherGender(false)} size="small" sx={{ ml: 1 }}>
//                           {t('common.change')}
//                         </Button>
//                       ),
//                     }}
//                   />
//                 )}
//               </Box>

//               <Box sx={{ minWidth: 200, flex: 1 }}>
//                 {!showOtherRelation ? (
//                   <FormControl fullWidth margin="normal" error={formik.touched.legal_heir_relation_with_depositor && Boolean(formik.errors.legal_heir_relation_with_depositor)}>
//                     <InputLabel>{t('legalHeir.relationWithDepositor')}</InputLabel>
//                     <Select name="legal_heir_relation_with_depositor" value={formik.values.legal_heir_relation_with_depositor || ""} label={t('legalHeir.relationWithDepositor')} onChange={handleRelationChange} onBlur={formik.handleBlur}>
//                       <MenuItem value="son">{t('legalHeir.son')}</MenuItem>
//                       <MenuItem value="daughter">{t('legalHeir.daughter')}</MenuItem>
//                       <MenuItem value="spouse">{t('legalHeir.spouse')}</MenuItem>
//                       <MenuItem value="brother">{t('legalHeir.brother')}</MenuItem>
//                       <MenuItem value="sister">{t('legalHeir.sister')}</MenuItem>
//                       <MenuItem value="other">{t('legalHeir.other')}</MenuItem>
//                     </Select>
//                     {formik.touched.legal_heir_relation_with_depositor && formik.errors.legal_heir_relation_with_depositor && (
//                       <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                         {formik.errors.legal_heir_relation_with_depositor}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 ) : (
//                   <TextField
//                     label={`${t('legalHeir.specifyRelation')} *`}
//                     name="legal_heir_relation_with_depositor"
//                     value={formik.values.legal_heir_relation_with_depositor}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     fullWidth
//                     error={formik.touched.legal_heir_relation_with_depositor && Boolean(formik.errors.legal_heir_relation_with_depositor)}
//                     helperText={formik.touched.legal_heir_relation_with_depositor && formik.errors.legal_heir_relation_with_depositor}
//                     InputProps={{
//                       endAdornment: (
//                         <Button onClick={() => setShowOtherRelation(false)} size="small" sx={{ ml: 1 }}>
//                           {t('common.change')}
//                         </Button>
//                       ),
//                     }}
//                   />
//                 )}
//               </Box>
//             </TwoFieldRow>

//             <UploadWithLabel
//               label={t('legalHeir.uploadDeathCert')}
//               name="legal_heir_death_certificate"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_death_certificate")}
//               file={formik.values.legal_heir_death_certificate}
//               error={formik.touched.legal_heir_death_certificate && Boolean(formik.errors.legal_heir_death_certificate)}
//               helperText={formik.touched.legal_heir_death_certificate && formik.errors.legal_heir_death_certificate}
//             />

//             <UploadWithLabel
//               label={t('legalHeir.uploadFamilyTree')}
//               name="legal_heir_family_tree"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_family_tree")}
//               file={formik.values.legal_heir_family_tree}
//               error={formik.touched.legal_heir_family_tree && Boolean(formik.errors.legal_heir_family_tree)}
//               helperText={formik.touched.legal_heir_family_tree && formik.errors.legal_heir_family_tree}
//             />

//             <UploadWithLabel
//               label={t('legalHeir.uploadPan')}
//               name="legal_heir_pan_doc"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_pan_doc")}
//               file={formik.values.legal_heir_pan_doc}
//               error={formik.touched.legal_heir_pan_doc && Boolean(formik.errors.legal_heir_pan_doc)}
//               helperText={formik.touched.legal_heir_pan_doc && formik.errors.legal_heir_pan_doc}
//             />

//             <FormControl fullWidth margin="normal" error={formik.touched.ekyc_doc_type && Boolean(formik.errors.ekyc_doc_type)} sx={selectFormControlSX}>
//               <InputLabel>{t('legalHeir.ekycDocType')}</InputLabel>
//               <Select name="ekyc_doc_type" value={formik.values.ekyc_doc_type} label={t('legalHeir.ekycDocType')} onChange={formik.handleChange} onBlur={formik.handleBlur}>
//                 <MenuItem value="pan">PAN</MenuItem>
//                 <MenuItem value="driving_license">{t('legalHeir.drivingLicense')}</MenuItem>
//                 <MenuItem value="passport">{t('legalHeir.passport')}</MenuItem>
//               </Select>
//               {formik.touched.ekyc_doc_type && formik.errors.ekyc_doc_type && <Typography color="error" variant="caption" sx={{ ml: 2 }}>{formik.errors.ekyc_doc_type}</Typography>}
//             </FormControl>

//             <UploadWithLabel
//               label={t('legalHeir.uploadEKYC')}
//               name="legal_heir_ekyc"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_ekyc")}
//               file={formik.values.legal_heir_ekyc}
//               error={formik.touched.legal_heir_ekyc && Boolean(formik.errors.legal_heir_ekyc)}
//               helperText={formik.touched.legal_heir_ekyc && formik.errors.legal_heir_ekyc}
//             />

//             <UploadWithLabel
//               label={t('legalHeir.uploadDisclosure')}
//               name="legal_heir_letter_of_disclosure"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_letter_of_disclosure")}
//               file={formik.values.legal_heir_letter_of_disclosure}
//               error={formik.touched.legal_heir_letter_of_disclosure && Boolean(formik.errors.legal_heir_letter_of_disclosure)}
//               helperText={formik.touched.legal_heir_letter_of_disclosure && formik.errors.legal_heir_letter_of_disclosure}
//             />

//             <Box mt={3} sx={{ display: "flex", justifyContent: "space-between" }}>
//               <Button variant="outlined" size="large" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
//                 {t('common.back')}
//               </Button>
//               <Button type="submit" variant="contained" size="large">
//                 {t('common.next')}
//               </Button>
//             </Box>
//           </Stack>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default LegalHeirInfoSection;


// v2 with pdf validation

// import React, { useState } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   FormControl,
//   InputLabel,
//   Select,
//   MenuItem,
//   Container,
//   Paper,
//   Stack,
// } from "@mui/material";
// import UploadWithLabel from "./uploadWithLable";
// import TwoFieldRow from "./twoFieldsRow";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const LegalHeirInfoSection = ({ legalHeir, setLegalHeir, activeTab, setActiveTab }) => {
//   const { t } = useTranslation();
//   const [showOtherGender, setShowOtherGender] = useState(false);
//   const [showOtherRelation, setShowOtherRelation] = useState(false);

//   const validationSchema = Yup.object({
//     legal_heir_name: Yup.string().required(t('legalHeir.validation.legalHeirNameRequired')),
//     legal_heir_gender: Yup.string().required(t('legalHeir.validation.genderRequired')),
//     legal_heir_relation_with_depositor: Yup.string().required(t('legalHeir.validation.relationRequired')),
//     legal_heir_death_certificate: Yup.mixed()
//       .required(t('legalHeir.validation.deathCertRequired'))
//       .test("fileExists", t('legalHeir.validation.deathCertRequired'), value => value != null)
//       .test("fileType", "Death certificate must be PDF only", value => !value || value.type === "application/pdf")
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     legal_heir_family_tree: Yup.mixed()
//       .required(t('legalHeir.validation.familyTreeRequired'))
//       .test("fileExists", t('legalHeir.validation.familyTreeRequired'), value => value != null)
//       .test("fileType", "Family tree must be PDF only", value => !value || value.type === "application/pdf")
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     legal_heir_pan_doc: Yup.mixed()
//       .required(t('legalHeir.validation.panRequired'))
//       .test("fileExists", t('legalHeir.validation.panRequired'), value => value != null)
//       .test("fileType", "PAN document must be PDF only", value => !value || value.type === "application/pdf")
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     legal_heir_ekyc: Yup.mixed()
//       .required(t('legalHeir.validation.ekycRequired'))
//       .test("fileExists", t('legalHeir.validation.ekycRequired'), value => value != null)
//       .test("fileType", "eKYC document must be PDF only", value => !value || value.type === "application/pdf")
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     legal_heir_letter_of_disclosure: Yup.mixed()
//       .required(t('legalHeir.validation.disclosureRequired'))
//       .test("fileExists", t('legalHeir.validation.disclosureRequired'), value => value != null)
//       .test("fileType", "Letter of disclosure must be PDF only", value => !value || value.type === "application/pdf")
//       .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
//     ekyc_doc_type: Yup.string().required(t('legalHeir.validation.ekycDocTypeRequired')),
//   });

//   const formik = useFormik({
//     initialValues: {
//       ...legalHeir,
//       ekyc_doc_type: legalHeir.ekyc_doc_type || "",
//     },
//     validationSchema,
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       setLegalHeir(values);
//       setActiveTab(activeTab + 1);
//     },
//   });

//   const handleFileChangeFormik = (e, fieldName) => {
//     const file = e.currentTarget.files[0] || null;
//     formik.setFieldValue(fieldName, file);
//     formik.setFieldTouched(fieldName, true);
//   };

//   const handleGenderChange = e => {
//     const value = e.target.value;
//     if (value === "other") {
//       setShowOtherGender(true);
//       formik.setFieldValue("legal_heir_gender", "");
//     } else {
//       setShowOtherGender(false);
//       formik.setFieldValue("legal_heir_gender", value);
//     }
//   };

//   const handleRelationChange = e => {
//     const value = e.target.value;
//     if (value === "other") {
//       setShowOtherRelation(true);
//       formik.setFieldValue("legal_heir_relation_with_depositor", "");
//     } else {
//       setShowOtherRelation(false);
//       formik.setFieldValue("legal_heir_relation_with_depositor", value);
//     }
//   };

//   const selectFormControlSX = { minWidth: 200, maxWidth: "100%" };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
//           {t('legalHeir.heading')}
//         </Typography>

//         <Box component="form" noValidate onSubmit={formik.handleSubmit}>
//           <Stack spacing={3}>
//             <TextField
//               margin="normal"
//               label={`${t('legalHeir.legalHeirName')} *`}
//               name="legal_heir_name"
//               value={formik.values.legal_heir_name}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               fullWidth
//               error={formik.touched.legal_heir_name && Boolean(formik.errors.legal_heir_name)}
//               helperText={formik.touched.legal_heir_name && formik.errors.legal_heir_name}
//             />

//             <TwoFieldRow>
//               <Box sx={{ minWidth: 200, flex: 1 }}>
//                 {!showOtherGender ? (
//                   <FormControl fullWidth margin="normal" error={formik.touched.legal_heir_gender && Boolean(formik.errors.legal_heir_gender)}>
//                     <InputLabel>{t('legalHeir.gender')}</InputLabel>
//                     <Select name="legal_heir_gender" value={formik.values.legal_heir_gender || ""} label={t('legalHeir.gender')} onChange={handleGenderChange} onBlur={formik.handleBlur}>
//                       <MenuItem value="male">{t('legalHeir.male')}</MenuItem>
//                       <MenuItem value="female">{t('legalHeir.female')}</MenuItem>
//                       <MenuItem value="other">{t('legalHeir.other')}</MenuItem>
//                     </Select>
//                     {formik.touched.legal_heir_gender && formik.errors.legal_heir_gender && (
//                       <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                         {formik.errors.legal_heir_gender}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 ) : (
//                   <TextField
//                     label={`${t('legalHeir.specifyGender')} *`}
//                     name="legal_heir_gender"
//                     value={formik.values.legal_heir_gender}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     fullWidth
//                     error={formik.touched.legal_heir_gender && Boolean(formik.errors.legal_heir_gender)}
//                     helperText={formik.touched.legal_heir_gender && formik.errors.legal_heir_gender}
//                     InputProps={{
//                       endAdornment: (
//                         <Button onClick={() => setShowOtherGender(false)} size="small" sx={{ ml: 1 }}>
//                           {t('common.change')}
//                         </Button>
//                       ),
//                     }}
//                   />
//                 )}
//               </Box>

//               <Box sx={{ minWidth: 200, flex: 1 }}>
//                 {!showOtherRelation ? (
//                   <FormControl fullWidth margin="normal" error={formik.touched.legal_heir_relation_with_depositor && Boolean(formik.errors.legal_heir_relation_with_depositor)}>
//                     <InputLabel>{t('legalHeir.relationWithDepositor')}</InputLabel>
//                     <Select name="legal_heir_relation_with_depositor" value={formik.values.legal_heir_relation_with_depositor || ""} label={t('legalHeir.relationWithDepositor')} onChange={handleRelationChange} onBlur={formik.handleBlur}>
//                       <MenuItem value="son">{t('legalHeir.son')}</MenuItem>
//                       <MenuItem value="daughter">{t('legalHeir.daughter')}</MenuItem>
//                       <MenuItem value="spouse">{t('legalHeir.spouse')}</MenuItem>
//                       <MenuItem value="brother">{t('legalHeir.brother')}</MenuItem>
//                       <MenuItem value="sister">{t('legalHeir.sister')}</MenuItem>
//                       <MenuItem value="other">{t('legalHeir.other')}</MenuItem>
//                     </Select>
//                     {formik.touched.legal_heir_relation_with_depositor && formik.errors.legal_heir_relation_with_depositor && (
//                       <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                         {formik.errors.legal_heir_relation_with_depositor}
//                       </Typography>
//                     )}
//                   </FormControl>
//                 ) : (
//                   <TextField
//                     label={`${t('legalHeir.specifyRelation')} *`}
//                     name="legal_heir_relation_with_depositor"
//                     value={formik.values.legal_heir_relation_with_depositor}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     fullWidth
//                     error={formik.touched.legal_heir_relation_with_depositor && Boolean(formik.errors.legal_heir_relation_with_depositor)}
//                     helperText={formik.touched.legal_heir_relation_with_depositor && formik.errors.legal_heir_relation_with_depositor}
//                     InputProps={{
//                       endAdornment: (
//                         <Button onClick={() => setShowOtherRelation(false)} size="small" sx={{ ml: 1 }}>
//                           {t('common.change')}
//                         </Button>
//                       ),
//                     }}
//                   />
//                 )}
//               </Box>
//             </TwoFieldRow>

//             <UploadWithLabel
//               label={t('legalHeir.uploadDeathCert')}
//               name="legal_heir_death_certificate"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_death_certificate")}
//               file={formik.values.legal_heir_death_certificate}
//               error={formik.touched.legal_heir_death_certificate && Boolean(formik.errors.legal_heir_death_certificate)}
//               helperText={formik.touched.legal_heir_death_certificate && formik.errors.legal_heir_death_certificate}
//             />

//             <UploadWithLabel
//               label={t('legalHeir.uploadFamilyTree')}
//               name="legal_heir_family_tree"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_family_tree")}
//               file={formik.values.legal_heir_family_tree}
//               error={formik.touched.legal_heir_family_tree && Boolean(formik.errors.legal_heir_family_tree)}
//               helperText={formik.touched.legal_heir_family_tree && formik.errors.legal_heir_family_tree}
//             />

//             <UploadWithLabel
//               label={t('legalHeir.uploadPan')}
//               name="legal_heir_pan_doc"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_pan_doc")}
//               file={formik.values.legal_heir_pan_doc}
//               error={formik.touched.legal_heir_pan_doc && Boolean(formik.errors.legal_heir_pan_doc)}
//               helperText={formik.touched.legal_heir_pan_doc && formik.errors.legal_heir_pan_doc}
//             />

//             <FormControl fullWidth margin="normal" error={formik.touched.ekyc_doc_type && Boolean(formik.errors.ekyc_doc_type)} sx={selectFormControlSX}>
//               <InputLabel>{t('legalHeir.ekycDocType')}</InputLabel>
//               <Select name="ekyc_doc_type" value={formik.values.ekyc_doc_type} label={t('legalHeir.ekycDocType')} onChange={formik.handleChange} onBlur={formik.handleBlur}>
//                 <MenuItem value="pan">PAN</MenuItem>
//                 <MenuItem value="driving_license">{t('legalHeir.drivingLicense')}</MenuItem>
//                 <MenuItem value="passport">{t('legalHeir.passport')}</MenuItem>
//               </Select>
//               {formik.touched.ekyc_doc_type && formik.errors.ekyc_doc_type && <Typography color="error" variant="caption" sx={{ ml: 2 }}>{formik.errors.ekyc_doc_type}</Typography>}
//             </FormControl>

//             <UploadWithLabel
//               label={t('legalHeir.uploadEKYC')}
//               name="legal_heir_ekyc"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_ekyc")}
//               file={formik.values.legal_heir_ekyc}
//               error={formik.touched.legal_heir_ekyc && Boolean(formik.errors.legal_heir_ekyc)}
//               helperText={formik.touched.legal_heir_ekyc && formik.errors.legal_heir_ekyc}
//             />

//             <UploadWithLabel
//               label={t('legalHeir.uploadDisclosure')}
//               name="legal_heir_letter_of_disclosure"
//               onChange={(e) => handleFileChangeFormik(e, "legal_heir_letter_of_disclosure")}
//               file={formik.values.legal_heir_letter_of_disclosure}
//               error={formik.touched.legal_heir_letter_of_disclosure && Boolean(formik.errors.legal_heir_letter_of_disclosure)}
//               helperText={formik.touched.legal_heir_letter_of_disclosure && formik.errors.legal_heir_letter_of_disclosure}
//             />

//             <Box mt={3} sx={{ display: "flex", justifyContent: "space-between" }}>
//               <Button variant="outlined" size="large" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
//                 {t('common.back')}
//               </Button>
//               <Button type="submit" variant="contained" size="large">
//                 {t('common.next')}
//               </Button>
//             </Box>
//           </Stack>
//         </Box>
//       </Paper>
//     </Container>
//   );
// };

// export default LegalHeirInfoSection;


import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Container,
  Paper,
  Stack,
} from "@mui/material";
import UploadWithLabel from "./uploadWithLable";
import TwoFieldRow from "./twoFieldsRow";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";

const LegalHeirInfoSection = ({ legalHeir, setLegalHeir, activeTab, setActiveTab }) => {
  const { t } = useTranslation();
  const [showOtherGender, setShowOtherGender] = useState(false);
  const [showOtherRelation, setShowOtherRelation] = useState(false);

  const validationSchema = Yup.object({
    legal_heir_name: Yup.string().required(t('legalHeir.validation.legalHeirNameRequired')),
    legal_heir_gender: Yup.string().required(t('legalHeir.validation.genderRequired')),
    legal_heir_relation_with_depositor: Yup.string().required(t('legalHeir.validation.relationRequired')),
    legal_heir_death_certificate: Yup.mixed()
      .required(t('legalHeir.validation.deathCertRequired'))
      .test("fileExists", t('legalHeir.validation.deathCertRequired'), value => value != null)
      .test("fileType", "Death certificate must be PDF only", value => !value || value.type === "application/pdf")
      .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
    legal_heir_family_tree: Yup.mixed()
      .required(t('legalHeir.validation.familyTreeRequired'))
      .test("fileExists", t('legalHeir.validation.familyTreeRequired'), value => value != null)
      .test("fileType", "Family tree must be PDF only", value => !value || value.type === "application/pdf")
      .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
    legal_heir_pan_doc: Yup.mixed()
      .required(t('legalHeir.validation.panRequired'))
      .test("fileExists", t('legalHeir.validation.panRequired'), value => value != null)
      .test("fileType", "PAN document must be PDF only", value => !value || value.type === "application/pdf")
      .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
    legal_heir_ekyc: Yup.mixed()
      .required(t('legalHeir.validation.ekycRequired'))
      .test("fileExists", t('legalHeir.validation.ekycRequired'), value => value != null)
      .test("fileType", "eKYC document must be PDF only", value => !value || value.type === "application/pdf")
      .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
    legal_heir_letter_of_disclosure: Yup.mixed()
      .required(t('legalHeir.validation.disclosureRequired'))
      .test("fileExists", t('legalHeir.validation.disclosureRequired'), value => value != null)
      .test("fileType", "Letter of disclosure must be PDF only", value => !value || value.type === "application/pdf")
      .test("fileSize", t('baseInfo.validation.fileSizeExceeded'), value => !value || value.size <= 2 * 1024 * 1024),
    ekyc_doc_type: Yup.string().required(t('legalHeir.validation.ekycDocTypeRequired')),
  });

  const formik = useFormik({
    initialValues: {
      ...legalHeir,
      ekyc_doc_type: legalHeir.ekyc_doc_type || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      setLegalHeir(values);
      setActiveTab(activeTab + 1);
    },
  });

  const handleFileChangeFormik = (e, fieldName) => {
    const file = e.currentTarget.files[0] || null;
    formik.setFieldValue(fieldName, file);
    formik.setFieldTouched(fieldName, true);
  };

  const handleGenderChange = e => {
    const value = e.target.value;
    if (value === "other") {
      setShowOtherGender(true);
      formik.setFieldValue("legal_heir_gender", "");
    } else {
      setShowOtherGender(false);
      formik.setFieldValue("legal_heir_gender", value);
    }
  };

  const handleRelationChange = e => {
    const value = e.target.value;
    if (value === "other") {
      setShowOtherRelation(true);
      formik.setFieldValue("legal_heir_relation_with_depositor", "");
    } else {
      setShowOtherRelation(false);
      formik.setFieldValue("legal_heir_relation_with_depositor", value);
    }
  };

  const selectFormControlSX = { minWidth: 200, maxWidth: "100%" };

  return (
    <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
      <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
        <Typography variant="h4" color="primary.main" fontWeight="700" align="center" gutterBottom>
          {t('legalHeir.heading')}
        </Typography>

        <Box component="form" noValidate onSubmit={formik.handleSubmit}>
          <Stack spacing={3}>
            <TextField
              margin="normal"
              label={`${t('legalHeir.legalHeirName')} *`}
              name="legal_heir_name"
              value={formik.values.legal_heir_name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              fullWidth
              error={formik.touched.legal_heir_name && Boolean(formik.errors.legal_heir_name)}
              helperText={formik.touched.legal_heir_name && formik.errors.legal_heir_name}
            />

            <TwoFieldRow>
              <Box sx={{ minWidth: 200, flex: 1 }}>
                {!showOtherGender ? (
                  <FormControl fullWidth margin="normal" error={formik.touched.legal_heir_gender && Boolean(formik.errors.legal_heir_gender)}>
                    <InputLabel>{t('legalHeir.gender')}</InputLabel>
                    <Select name="legal_heir_gender" value={formik.values.legal_heir_gender || ""} label={t('legalHeir.gender')} onChange={handleGenderChange} onBlur={formik.handleBlur}>
                      <MenuItem value="male">{t('legalHeir.male')}</MenuItem>
                      <MenuItem value="female">{t('legalHeir.female')}</MenuItem>
                      <MenuItem value="other">{t('legalHeir.other')}</MenuItem>
                    </Select>
                    {formik.touched.legal_heir_gender && formik.errors.legal_heir_gender && (
                      <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                        {formik.errors.legal_heir_gender}
                      </Typography>
                    )}
                  </FormControl>
                ) : (
                  <TextField
                    label={`${t('legalHeir.specifyGender')} *`}
                    name="legal_heir_gender"
                    value={formik.values.legal_heir_gender}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    error={formik.touched.legal_heir_gender && Boolean(formik.errors.legal_heir_gender)}
                    helperText={formik.touched.legal_heir_gender && formik.errors.legal_heir_gender}
                    InputProps={{
                      endAdornment: (
                        <Button onClick={() => setShowOtherGender(false)} size="small" sx={{ ml: 1 }}>
                          {t('common.change')}
                        </Button>
                      ),
                    }}
                  />
                )}
              </Box>

              <Box sx={{ minWidth: 200, flex: 1 }}>
                {!showOtherRelation ? (
                  <FormControl fullWidth margin="normal" error={formik.touched.legal_heir_relation_with_depositor && Boolean(formik.errors.legal_heir_relation_with_depositor)}>
                    <InputLabel>{t('legalHeir.relationWithDepositor')}</InputLabel>
                    <Select name="legal_heir_relation_with_depositor" value={formik.values.legal_heir_relation_with_depositor || ""} label={t('legalHeir.relationWithDepositor')} onChange={handleRelationChange} onBlur={formik.handleBlur}>
                      <MenuItem value="son">{t('legalHeir.son')}</MenuItem>
                      <MenuItem value="daughter">{t('legalHeir.daughter')}</MenuItem>
                      <MenuItem value="spouse">{t('legalHeir.spouse')}</MenuItem>
                      <MenuItem value="brother">{t('legalHeir.brother')}</MenuItem>
                      <MenuItem value="sister">{t('legalHeir.sister')}</MenuItem>
                      <MenuItem value="other">{t('legalHeir.other')}</MenuItem>
                    </Select>
                    {formik.touched.legal_heir_relation_with_depositor && formik.errors.legal_heir_relation_with_depositor && (
                      <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                        {formik.errors.legal_heir_relation_with_depositor}
                      </Typography>
                    )}
                  </FormControl>
                ) : (
                  <TextField
                    label={`${t('legalHeir.specifyRelation')} *`}
                    name="legal_heir_relation_with_depositor"
                    value={formik.values.legal_heir_relation_with_depositor}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    fullWidth
                    error={formik.touched.legal_heir_relation_with_depositor && Boolean(formik.errors.legal_heir_relation_with_depositor)}
                    helperText={formik.touched.legal_heir_relation_with_depositor && formik.errors.legal_heir_relation_with_depositor}
                    InputProps={{
                      endAdornment: (
                        <Button onClick={() => setShowOtherRelation(false)} size="small" sx={{ ml: 1 }}>
                          {t('common.change')}
                        </Button>
                      ),
                    }}
                  />
                )}
              </Box>
            </TwoFieldRow>

            <UploadWithLabel
              label={t('legalHeir.uploadDeathCert')}
              name="legal_heir_death_certificate"
              onChange={(e) => handleFileChangeFormik(e, "legal_heir_death_certificate")}
              file={formik.values.legal_heir_death_certificate}
              error={formik.touched.legal_heir_death_certificate && Boolean(formik.errors.legal_heir_death_certificate)}
              helperText={formik.touched.legal_heir_death_certificate && formik.errors.legal_heir_death_certificate}
            />
            {formik.touched.legal_heir_death_certificate && formik.errors.legal_heir_death_certificate && !formik.values.legal_heir_death_certificate && (
              <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                {formik.errors.legal_heir_death_certificate}
              </Typography>
            )}

            <UploadWithLabel
              label={t('legalHeir.uploadFamilyTree')}
              name="legal_heir_family_tree"
              onChange={(e) => handleFileChangeFormik(e, "legal_heir_family_tree")}
              file={formik.values.legal_heir_family_tree}
              error={formik.touched.legal_heir_family_tree && Boolean(formik.errors.legal_heir_family_tree)}
              helperText={formik.touched.legal_heir_family_tree && formik.errors.legal_heir_family_tree}
            />
            {formik.touched.legal_heir_family_tree && formik.errors.legal_heir_family_tree &&  !formik.values.legal_heir_family_tree &&(
              <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                {formik.errors.legal_heir_family_tree}
              </Typography>
            )}

            <UploadWithLabel
              label={t('legalHeir.uploadPan')}
              name="legal_heir_pan_doc"
              onChange={(e) => handleFileChangeFormik(e, "legal_heir_pan_doc")}
              file={formik.values.legal_heir_pan_doc}
              error={formik.touched.legal_heir_pan_doc && Boolean(formik.errors.legal_heir_pan_doc)}
              helperText={formik.touched.legal_heir_pan_doc && formik.errors.legal_heir_pan_doc}
            />
            {formik.touched.legal_heir_pan_doc && formik.errors.legal_heir_pan_doc && !formik.values.legal_heir_pan_doc && (
              <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                {formik.errors.legal_heir_pan_doc}
              </Typography>
            )}

            <FormControl fullWidth margin="normal" error={formik.touched.ekyc_doc_type && Boolean(formik.errors.ekyc_doc_type)} sx={selectFormControlSX}>
              <InputLabel>{t('legalHeir.ekycDocType')}</InputLabel>
              <Select name="ekyc_doc_type" value={formik.values.ekyc_doc_type} label={t('legalHeir.ekycDocType')} onChange={formik.handleChange} onBlur={formik.handleBlur}>
                <MenuItem value="pan">PAN</MenuItem>
                <MenuItem value="driving_license">{t('legalHeir.drivingLicense')}</MenuItem>
                <MenuItem value="passport">{t('legalHeir.passport')}</MenuItem>
              </Select>
              {formik.touched.ekyc_doc_type && formik.errors.ekyc_doc_type && (
                <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                  {formik.errors.ekyc_doc_type}
                </Typography>
              )}
            </FormControl>

            <UploadWithLabel
              label={t('legalHeir.uploadEKYC')}
              name="legal_heir_ekyc"
              onChange={(e) => handleFileChangeFormik(e, "legal_heir_ekyc")}
              file={formik.values.legal_heir_ekyc}
              error={formik.touched.legal_heir_ekyc && Boolean(formik.errors.legal_heir_ekyc)}
              helperText={formik.touched.legal_heir_ekyc && formik.errors.legal_heir_ekyc}
            />
            {formik.touched.legal_heir_ekyc && formik.errors.legal_heir_ekyc && !formik.values.legal_heir_ekyc &&(
              <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                {formik.errors.legal_heir_ekyc}
              </Typography>
            )}

            <UploadWithLabel
              label={t('legalHeir.uploadDisclosure')}
              name="legal_heir_letter_of_disclosure"
              onChange={(e) => handleFileChangeFormik(e, "legal_heir_letter_of_disclosure")}
              file={formik.values.legal_heir_letter_of_disclosure}
              error={formik.touched.legal_heir_letter_of_disclosure && Boolean(formik.errors.legal_heir_letter_of_disclosure)}
              helperText={formik.touched.legal_heir_letter_of_disclosure && formik.errors.legal_heir_letter_of_disclosure}
            />
            {formik.touched.legal_heir_letter_of_disclosure && formik.errors.legal_heir_letter_of_disclosure && !formik.values.legal_heir_letter_of_disclosure &&(
              <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                {formik.errors.legal_heir_letter_of_disclosure}
              </Typography>
            )}

            <Box mt={3} sx={{ display: "flex", justifyContent: "space-between" }}>
              <Button variant="outlined" size="large" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
                {t('common.back')}
              </Button>
              <Button 
                type="submit" 
                variant="contained" 
                size="large"
                sx={{
                  "&.Mui-disabled": {
                    backgroundColor: "rgba(25, 118, 210, 0.6)",
                    color: "rgba(255, 255, 255, 0.9)",
                    cursor: "not-allowed",
                  },
                }}
              >
                {t('common.next')}
              </Button>
            </Box>
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
};

export default LegalHeirInfoSection;
